import React from 'react';
import { useAuth } from '../../context/AuthContext';
import styles from './ChipFilter.module.scss';
import Avatar from '../Avatar/Avatar';
import { getAvatarSrc } from '../../utils/avatarUtils';

function ChipFilter({ selectedMembers, teamMembers, onChipClick }) {
  const { user } = useAuth();
  
  return (
    <div className={styles.container}>
      <span
        className={`${styles.chip} ${selectedMembers.includes('all') ? styles.selected : ''}`}
        onClick={() => onChipClick('all')}
      >
        All
      </span>
      {teamMembers.map(member => {
        return (
          <span
            key={member.id}
            className={`${styles.chip} ${selectedMembers.includes(String(member.id)) ? styles.selected : ''}`}
            onClick={() => onChipClick(String(member.id))}
          >
            <Avatar 
              src={getAvatarSrc(member, user)} 
              name={member.name} 
              size="xsmall"
              className={styles.avatar}
            />
            {member.name}
          </span>
        );
      })}
    </div>
  );
}

export default ChipFilter; 